// Central place for the application brand name
// You can override this via REACT_APP_APP_NAME in your .env
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'SALOONE';
